import { boolean, mixedObj, string, object, constraints } from "./helpers";
import { DeviceSettingOptions } from "./settingOptions";
import { General } from "./types";

export const general = object<General>({
  language: object({
    value: mixedObj(DeviceSettingOptions.languageOpts, "LANGUAGE")
  }),
  battery_status_alert: object({
    value: boolean("BATTERY_STATUS"),
    constraints: constraints()
  }),
  sensor_settings_enabled: object({
    value: boolean("SENSOR_SETTINGS"),
    constraints: constraints()
  }),
  charge_vibration: object({
    value: boolean("CHARGE_VIBRATION"),
    constraints: constraints()
  }),
  restore_defaults: object({
    value: string("RESTORE_DEFAULTS"),
    constraints: constraints()
  })
}).required();
